// src/tasks/EditTaskModal.jsx
import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../api";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";

const EditTaskModal = ({ show, onHide, task, onUpdated }) => {
  const [form, setForm] = useState({
    title: "",
    description: "",
    deadline: null,
    status: "assigned",
    assigned_to: "",
  });
  const TASK_STATUS_LABELS = {
  assigned: "اختصاص داده شده",
  in_progress: "در حال انجام",
  completed: "تکمیل شده",
};

  useEffect(() => {
    if (task) {
      setForm({
        title: task.title || "",
        description: task.description || "",
        deadline : task.deadline || null,
        status: task.status || "assigned",
        assigned_to: task.assigned_to || "",
      });
    }
  }, [task]);

  const submit = () => {
    api
      .patch(`/tasks/${task.id}/`, form)
      .then(() => {
        onUpdated();
        onHide();
      });
  };

  if (!task) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>ویرایش تسک</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>عنوان</Form.Label>
          <Form.Control
            value={form.title}
            onChange={e => setForm({ ...form, title: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>توضیحات</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={form.description}
            onChange={e =>
              setForm({ ...form, description: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>سررسید</Form.Label>
            <DatePicker
            value={form.deadline}
            onChange={e =>
              setForm({ ...form, deadline: e.target.value })}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            inputClass="form-control"
            format="YYYY-MM-DD"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>وضعیت</Form.Label>
          <Form.Select
            value={form.status}
            onChange={e => setForm({ ...form, status: e.target.value })}
          >
            {Object.entries(TASK_STATUS_LABELS).map(([v, l]) => (
              <option key={v} value={v}>
                {l}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          انصراف
        </Button>
        <Button variant="primary" onClick={submit}>
          ذخیره تغییرات
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditTaskModal;
